import { render, staticRenderFns } from "./extremeWeatherCondicionsDatabase.vue?vue&type=template&id=6870ca9c&"
import script from "./extremeWeatherCondicionsDatabase.vue?vue&type=script&lang=js&"
export * from "./extremeWeatherCondicionsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports